import React, { useContext, useState } from 'react';
import ReactPlayer from 'react-player';
import styles from '../../boardOne/BragifyEmbed.module.css';
import SlideShow from '../SlideShow';
import { AnalyticsEvents, AnalyticsScores } from '../../consts';
import { getMediaType } from '../../utils';

const ModalContext = React.createContext();

const ModalProvider = ({ children }) => {
  const [selectedPost, setSelectedPost] = useState({});
  const [referredPost, setReferredPost] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [postsOpened, setPostsOpened] = useState(1);

  const getReferredPost = (item) => {
    setReferredPost(item);
  };
  const showPostMedia = (item) => {
    if (item.media && item.media.length > 1) {
      return (
        <div className={styles.slideshow} aria-label={item.altText}>
          <SlideShow media={item.media} />
        </div>
      );
    }
    const post = item.media && item.media[0] ? item.media[0] : {};
    if (post.video) {
      return (
        <div className={styles.video}>
          <ReactPlayer
            playsinline
            className={styles['video-player']}
            url={post.video}
            playing
            controls
          />
        </div>
      );
    }
    if (post.large) {
      return (
        <div className={styles.image}>
          <img src={post.large} alt={item.altText || 'user generated image'} loading="lazy" />
        </div>
      );
    }

    return null;
  };

  const handleModalNavigate = (isForward, posts, index, modalRepeat, embedType) => {
    let newSelectedPost = index;
    if (modalRepeat) {
      if (!isForward) {
        if (index === 0) {
          newSelectedPost = posts.length - 1;
        } else {
          newSelectedPost = index - 1;
        }
      } else if (isForward) {
        if (index === posts.length - 1) {
          newSelectedPost = 0;
        } else {
          newSelectedPost = index + 1;
        }
      }
    } else if (!modalRepeat) {
      if (index > 0 && !isForward) {
        newSelectedPost = index - 1;
      } else if (index + 1 < posts.length && isForward) {
        newSelectedPost = index + 1;
      }
    }

    setSelectedPost(newSelectedPost);
    const item = posts[newSelectedPost] || {};
    giggAnalytics.logEvent(AnalyticsEvents.OPEN_POST, {
      boardId: __gigg.accountId,
      boardType: embedType,
      folderId: __gigg.folderId,
      postIndex: newSelectedPost,
      postId: item.id,
      postType: item.service,
      mediaType: getMediaType(item.media),
      isCarousel: item.media?.length > 1,
      scoreWeight: AnalyticsScores.SECOND_OPEN_POST,
      firstEvent: {
        _id: window.giggFirstEvent?._id,
        createdDate: window.giggFirstEvent?.createdDate,
      },
    });
  };

  const openModal = (index, item, embedType) => {
    setModalIsOpen(true);
    if (index === -1) {
      setPostsOpened((counter) => counter + 1);
      return;
    }
    setSelectedPost(index);
    setPostsOpened((counter) => counter + 1);
    giggAnalytics.logEvent(AnalyticsEvents.OPEN_POST, {
      boardId: __gigg.accountId,
      boardType: embedType,
      folderId: __gigg.folderId,
      postIndex: index,
      postId: item.id,
      postType: item.service,
      mediaType: getMediaType(item.media),
      isCarousel: item.media?.length > 1,
      scoreWeight: postsOpened > 1 ? AnalyticsScores.SECOND_OPEN_POST : AnalyticsScores.OPEN_POST,
      firstEvent: {
        _id: window.giggFirstEvent?._id,
        createdDate: window.giggFirstEvent?.createdDate,
      },
    });
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedPost({});
    setReferredPost(null);
  };

  const modalUtils = {
    showPostMedia,
    handleModalNavigate,
    selectedPost,
    referredPost,
    getReferredPost,
    modalIsOpen,
    openModal,
    closeModal,
  };
  return (
    <ModalContext.Provider value={modalUtils}>
      {typeof children === 'function' ? children(modalUtils) : children}
    </ModalContext.Provider>
  );
};

const useModal = () => {
  const {
    showPostMedia,
    handleModalNavigate,
    selectedPost,
    referredPost,
    getReferredPost,
    modalIsOpen,
    openModal,
    closeModal,
  } = useContext(ModalContext);
  return {
    showPostMedia,
    handleModalNavigate,
    selectedPost,
    referredPost,
    getReferredPost,
    modalIsOpen,
    openModal,
    closeModal,
  };
};

export { ModalProvider, useModal };
